import {
  SAVE_RECORDING_METADATA,
  SAVE_RECORDING_METADATA_SUCCESS,
  SAVE_RECORDING_METADATA_FAILURE,
} from './constants';

export function saveRecordingMetadata(recordingData) {
  return {
    type: SAVE_RECORDING_METADATA,
    recordingData,
  };
}

export const saveRecordingMetadataSuccess = (recording) => ({
  type: SAVE_RECORDING_METADATA_SUCCESS,
  recording,
});

export const saveRecordingMetadataFailure = (error) => ({
  type: SAVE_RECORDING_METADATA_FAILURE,
  error,
});

// export function getAllRecordings(filters = {}) {
//   return {
//     type: GET_ALL_RECORDINGS,
//     payload: filters,
//   };
// }
// export function getAllRecordingsSuccess(payload) {
//   return {
//     type: GET_ALL_RECORDINGS_SUCCESS,
//     payload,
//   };
// }

// export function getAllRecordingsError(error) {
//   return {
//     type: GET_ALL_RECORDINGS_ERROR,
//     error,
//   };
// }
